import type { ComponentPropsWithRef, CSSProperties, ReactNode } from "react";
import { cn } from "../../lib/cn";

export interface AspectRatioProps extends ComponentPropsWithRef<"div"> {
  /** Ratio d'aspect cible (ex: 16/9, 4/3, 1/1, 21/9 ou valeur décimale 1.777). Par défaut 16/9. */
  ratio?: number;
  children?: ReactNode;
}

/**
 * Conteneur d'aspect ratio réactif SOTA.
 * Préserve le ratio d'affichage d'un média (image, vidéo, carte) sans layout shift.
 */
export function AspectRatio({ className, ratio = 16 / 9, style, children, ...props }: AspectRatioProps) {
  const customStyle: CSSProperties = {
    ...style,
    aspectRatio: `${ratio}`,
  };

  return (
    <div
      className={cn("relative w-full overflow-hidden [&_img]:size-full [&_img]:object-cover [&_video]:size-full [&_video]:object-cover", className)}
      style={customStyle}
      {...props}
    >
      {children}
    </div>
  );
}
